import React, { useRef, useState } from "react";
import InputField from "./InputField";
import { QRCode } from "react-qrcode-logo";
import SelectField from "./SelectField";
import TextArea from "./TextArea";
import ImageUploadField from "./ImageUploadField";
import CheckboxField from "./CheckboxField";
import ReactJson from "react-json-view";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { Modal, Box, Typography } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { toPng } from "html-to-image";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import { getToken } from "../../../utils/auth";
import Canvas2Image from 'canvas2image';

const File = ({userData}) => {
  const [state, setState] = useState({
    value: "https://demo.dirido.com/",
    // logoImage: (!userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)
    //   ? "./diridologo.jpg" 
    //   : "",
      logoImage: "./diridologo.jpg",
    logoWidth: "36",
  enableCORS: true, 
  removeQrCodeBehindLogo: true 
  }); 

    const ref = useRef();
  const [inputValue, setInputValue] = useState("");
  const [textAreaValue, setTextAreaValue] = useState("");
  const [reservedQrcIdError, setReservedQrcIdError] = useState("");
  const [secretKeyError, setSecretKeyError] = useState("");
  const [isRegisterQRSelected, setIsRegisterQRSelected] = useState(false);
  const [reservedQRCId, setReservedQRCId] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [qrCodeUrlImage, setQrCodeUrlImage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => setOpen(false);

  const handleRegisterQRChange = (e) => {
    setIsRegisterQRSelected(e.target.checked);
  };

  const handleChange = ({ target }) => {
    setState((prevState) => ({ ...prevState, [target.name]: target.value }));
  };

  const handleDownload = async () => {
    if (ref.current) {
      try {
        // Add a small delay to ensure QR code and text are fully rendered
        setTimeout(async () => {
          const dataUrl = await toPng(ref.current, { pixelRatio: 2 });
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'qr-code-with-text.png';
          link.click();
        }, 100); // 100ms delay to ensure rendering is complete
      } catch (error) {
        console.error('Error downloading the image:', error);
      }
    }
  };

  const buildEyeRadiusInput = (id) => {
    return (
      <InputField
        name={id}
        type="range"
        handleChange={handleChange}
        min={0}
        max={50}
        hideLabel
        defaultValue={state[id]}
      />
    );
  };
  const [url, setUrl] = useState("");
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const handleUrlChange = (e) => {
    setUrl(e.target.value);
  };

  const handlePlatformChange = (e) => {
    setSelectedPlatform(e.target.value);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const [qrcID, setQrcID] = useState("");
  const [qrcData, setQrcData] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

 

  let acceptType = "";
  if (selectedPlatform === "image") {
    acceptType = "image/*";
  } else if (selectedPlatform === "pdf") {
    acceptType = "application/pdf";
  } else if (selectedPlatform === "video") {
    acceptType = "video/*";
  }


  const handleQRC = async () => {
    if (!selectedPlatform) {
      toast.info("File type is required!");
      return;
    }
    if (!selectedFile) {
      toast.info("Please select file!");
      return;
    }
    try {
      setLoading(true); 

      const token = getToken();
      const formData = new FormData();
      formData.append("file", selectedFile);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //   console.log("image",response.data.data);
      const uploadProfile = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/generate`,
        {
          qrcCategory: "file",
          fileData: {
            fileLink: response.data.data,
            fileSize: "20Mb",
            fileType: acceptType,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleButtonClick(uploadProfile.data.data.qrCodeData, uploadProfile.data.data.qrcId);
      //   console.log("data image", uploadProfile.data.data.qrCodeData);
      toast.success("File Uploaded Succesfully");
    } catch (error) {
      toast.error(error.response.data.message);

      console.error("Failed uploading file", error);
      setLoading(false);
    }  
  };
  const handleQRC1 = async () => {
    if (isRegisterQRSelected) {
      if (!reservedQRCId) {
        setReservedQrcIdError("Reserved QRC ID is required.");
        return;
      }
      if (!secretKey) {
        setSecretKeyError("Secret Key is required.");
        return;
      }
    }
    if (!selectedPlatform) {
      toast.info("File type is required!");
      return;
    }
    if (!selectedFile) {
      toast.info("Please select file!");
      return;
    }
    try {
      setLoading(true); 

      const token = getToken();
      const formData = new FormData();
      formData.append("file", selectedFile);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //   console.log("image",response.data.data);
      const uploadProfile = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/generate`,
        {
          qrcCategory: "file",
          isReserved: true,
          reservedQrcId: reservedQRCId,
          secretKey: secretKey,
          fileData: {
            fileLink: response.data.data,
            fileSize: "20Mb",
            fileType: acceptType,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleButtonClick(uploadProfile.data.data.qrCodeData, uploadProfile.data.data.qrcId);
      //   console.log("data image", uploadProfile.data.data.qrCodeData);
      toast.success("File Uploaded Succesfully");
    } catch (error) {
      toast.error(error.response.data.message);

      console.error("Failed uploading file", error);
      setLoading(false);
    }  
  };

  const [showReset, setShowReset] = useState(false);

  const handleButtonClick = (qrlink, qrid) => {
    setState((prevState) => ({ ...prevState, value: qrlink }));
    setShowReset(true);
    handleUpdateQRCode(qrid);
  };

    // const handleUpdateQRCode = async (qrid) => {
    //   if (ref.current) {
    //     try {
    //       setLoading(true);
    //       setTimeout(async () => {
    //         const dataUrl = await toPng(ref.current, { pixelRatio: 2 });
    //         const base64Data = dataUrl.split(",")[1];
    //         updateQRCode(base64Data, qrid);
    //       }, 200);
    //     } catch (error) {
    //       setLoading(false);
    //       console.error("Error processing QR image:", error);
    //     }
    //   }
    // };

const handleUpdateQRCode = async (qrid) => {
  if (ref.current) {
    try {
      setLoading(true);
      
      setTimeout(async () => {
        // Get the canvas from QRCode component
        const canvas = ref.current.querySelector('canvas');
        
        if (canvas) {
          // Convert canvas to blob (better iOS support)
          canvas.toBlob(async (blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64Data = reader.result.split(',')[1];
              updateQRCode(base64Data, qrid);
            };
            reader.readAsDataURL(blob);
          }, 'image/png');
        }
      }, 500);
    } catch (error) {
      setLoading(false);
      console.error("Error processing QR image:", error);
    }
  }
};
    const updateQRCode = async (base64Data, qrcId) => {
      try {
        setLoading(true); 
        const token = getToken();
        const putPayload = {
          qrCodeUrl: `data:image/png;base64,${base64Data}`,
        };
    
        await axios.put(
          `${process.env.REACT_APP_URL}/api/qrc/social-net/${qrcId}`,
          putPayload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        toast.success("QR Code generated successfully!");
        setQrCodeUrlImage(`data:image/png;base64,${base64Data}`);
        setOpen(true); 
      } catch (error) {
        console.error("Error updating QR Code:", error);
        toast.error(error?.response?.data?.message ||"Failed to generate QR Code.");
      }  finally {
        setLoading(false);
      }
    };
  const initialState = {
    value: "https://demo.dirido.com/",
    qrStyle: "squares",
    logoImage: "",
    logoWidth:36,
    logoPadding: 0,
    logoPaddingStyle: "square",
    bgColor: "#ffffff",
    fgColor: "#000000",
    logoHeight: 30,
    quietZone: 20,
    ecLevel: "M",
    removeQrCodeBehindLogo: true,
    enableCORS: true,
    logoOpacity: 1,
    size: 150,
    eyeradius_0_outer_0: 0,
    eyeradius_0_outer_1: 0,
    eyeradius_0_outer_2: 0,
    eyeradius_0_outer_3: 0,
    eyeradius_0_inner_0: 0,
    eyeradius_0_inner_1: 0,
    eyeradius_0_inner_2: 0,
    eyeradius_0_inner_3: 0,
    eyeradius_1_outer_0: 0,
    eyeradius_1_outer_1: 0,
    eyeradius_1_outer_2: 0,
    eyeradius_1_outer_3: 0,
    eyeradius_1_inner_0: 0,
    eyeradius_1_inner_1: 0,
    eyeradius_1_inner_2: 0,
    eyeradius_1_inner_3: 0,
    eyeradius_2_outer_0: 0,
    eyeradius_2_outer_1: 0,
    eyeradius_2_outer_2: 0,
    eyeradius_2_outer_3: 0,
    eyeradius_2_inner_0: 0,
    eyeradius_2_inner_1: 0,
    eyeradius_2_inner_2: 0,
    eyeradius_2_inner_3: 0,
    eyecolor_0_outer: "#000000",
    eyecolor_0_inner: "#000000",
    eyecolor_1_outer: "#000000",
    eyecolor_1_inner: "#000000",
    eyecolor_2_outer: "#000000",
    eyecolor_2_inner: "#000000",
  };
  
  const handleReset = () => {
    setState(initialState);
    setInputValue("");
    setSelectedPlatform("");
    setQrcID("");
    setQrcData("");
    setShowReset(false);
    setSelectedFile("");
  
  };


  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
{loading && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
<div></div>
<div>
        <div className="containerqrc">
          <div className="contqrc">
            <div style={{ marginBottom: "10px" }}>
              <span className="stepbutton">{t('step')} 1</span>
              <span className="steplabel">{t('select_file')}</span>
            </div>
            <div style={{ marginBottom: "10px" }}>
          <label>
            <input
              type="checkbox"
              checked={isRegisterQRSelected}
              onChange={handleRegisterQRChange}
            />
            {t('register_qr')}
          </label>
        </div>
        {isRegisterQRSelected && (
        <>
        <div>
                              <label style={{ fontSize: "18px" }}>
                              {t('reserved_qrc_id')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                value={reservedQRCId}
                onChange={(e) => setReservedQRCId(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {reservedQrcIdError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {reservedQrcIdError}
              </div>
            )}
                            </div>
                            <div>
                              <label style={{ fontSize: "18px" }}>
                              {t('secret_key')} <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                value={secretKey}
                onChange={(e) => setSecretKey(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  border: "1px solid #d4d4d4",
                                  marginBottom: "10px",
                                }}
                              />
                              {secretKeyError && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {secretKeyError}
              </div>
            )}
                            </div>
                            </>)}
            <div>
              <div
                className="radioContainer"
                style={{ overflowX: "auto" }}
                onChange={handlePlatformChange}
              >
                <label className="radioLabel">
                  <input
                    type="radio"
                    name="platform"
                    value="image"
                    className="radioInput"
                  />
                  {t('image')}
                </label>

                <label className="radioLabel">
                  <input
                    type="radio"
                    name="platform"
                    value="pdf"
                    className="radioInput"
                  />
                  {t('pdf')}
                </label>
                <label className="radioLabel">
                  <input
                    type="radio"
                    name="platform"
                    value="video"
                    className="radioInput"
                  />
                  {t('video')}
                </label>
              </div>
              <div>
                {selectedPlatform && (
                  <label
                    htmlFor="file-input"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      className="bg-soft-primary rounded p-1 pointer"
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "1.2rem",
                        position: "relative",
                        borderRadius: "10px",
                      }}
                    >
                      <input
                        id="file-input"
                        type="file"
                        name="image"
                        accept={acceptType}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      <span>
                        <i className="fas fa-upload"></i>
                      </span>
                      <p style={{ marginTop: ".5rem" }}>
                        {t('click_to_select_files')}
                      </p>
                    </div>
                    {selectedFile && (
                      <div style={{ marginTop: "10px", textAlign: "center" }}>
                        {t('selected_file')} - {selectedFile.name}
                      </div>
                    )}
                  </label>
                )}
              </div>
            </div>

          </div>
          <div className="contqrcsecond">
            <div className="section" style={{ width: "100%" }}>
            <div style={{display:"flex", flexDirection:"row", alignItems:"center"}}>
                <span className="stepbutton">{t('step')} 2</span>
                <span className="steplabel">{t('customize_qr_code')}</span>
                {showReset && (
                  <button  className="btn btn-primary d-block " onClick={handleReset}
                    style={{
                      width: "150px",
                      display:"flex",
                      marginLeft:"auto"
                    }}>{t('reset')}</button>)}
              </div>
              {/* Upper Properties */}
              <div className="containerproperties">
                <div className="subcontainer">
                  <div className="properties">
                    <SelectField
                      name="qrStyle"
                      options={["squares", "dots", "fluid"]}
                      handleChange={handleChange}
                      label={t('qr_style')}
                    />
                  </div>
                  <div className="properties" style={{
    pointerEvents: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 'none' : 'auto',
    opacity: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 0.5 : 1
  }}>
                    <ImageUploadField
                      name="logoImage"
                      handleChange={handleChange}
                      label={t('logo_image')}
                    />
                  </div>
                  <InputField
                    name="logoWidth"
                    type="range"
                    handleChange={handleChange}
                    min={10}
                    max={40}
                    label={t('logo_width')}
                  />

                  <InputField
                    name="logoPadding"
                    type="range"
                    handleChange={handleChange}
                    min={0}
                    max={5}
                    step={1}
                    defaultValue={0}
                    label={t('logo_padding')}
                  />
                </div>
                <div className="subcontainer">
                  <div className="properties">
                    <SelectField
                      name="logoPaddingStyle"
                      options={["square", "circle"]}
                      handleChange={handleChange}
                      label={t('logo_padding_style')}
                    />
                  </div>

                  <div
                    className="properties"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                    }}
                  >
                    <InputField
                      name="bgColor"
                      type="color"
                      defaultValue="#ffffff"
                      handleChange={handleChange}
                      label={t('bg_color')}
                    />
                    <InputField
                      name="fgColor"
                      type="color"
                      defaultValue="#000000"
                      handleChange={handleChange}
                      label={t('fg_color')}
                    />
                  </div>
                  <InputField
                    name="logoHeight"
                    type="range"
                    handleChange={handleChange}
                    min={10}
                    max={40}
                    label={t('logo_height')}
                  />
                  <InputField
                    name="quietZone"
                    type="range"
                    handleChange={handleChange}
                    min={20}
                    max={80}
                    label={t('quiet_zone')}
                  />
                </div>
                <div className="subcontainer">
                  <div className="properties">
                    <SelectField
                      name="ecLevel"
                      options={["L", "M", "Q", "H"]}
                      handleChange={handleChange}
                      label={t('ec_level')}
                    />
                  </div>
                  <div className="properties">
                  
                    <CheckboxField
                      name=" enableCORS"
                      handleChange={handleChange}
                      label={t('enable_cors')}
                    />
                  </div>
                  <div className="properties" style={{
    pointerEvents: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 'none' : 'auto',
    opacity: (!userData?.isEnrolledInSocialNet || (userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid)) ? 0.5 : 1
  }}>
                  <InputField
                    name="logoOpacity"
                    type="range"
                    handleChange={handleChange}
                    min={0}
                    max={1}
                    step={0.1}
                    defaultValue={1}
                    label={t('logo_opacity')}
                  />
</div>
                  <InputField
                    name="size"
                    type="range"
                    handleChange={handleChange}
                    min={100}
                    max={220}
                    label={t('range')}
                  />
                </div>
              </div>

              {/* QR Code  */}
              <div 
                 style={{
                  width: 300,
                  border:"2px solid red",
                  marginInline: "auto",
                  height: 300, 
                  padding: '10px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: '1px solid #d4fafc',
                  borderRadius: '50px',
                  backgroundColor: '#d4fafc',}}
              >
                <div ref={ref} style={{ display:"flex", flexDirection:"column"}}>
                <QRCode
                   style={{display:"flex"}}
                  // logoOnLoad={(e) => console.log("logo loaded", e)}
                  {...{
                    ...state,
                    eyeRadius: [
                      // build eyeRadius manually
                      {
                        outer: [
                          state.eyeradius_0_outer_0,
                          state.eyeradius_0_outer_1,
                          state.eyeradius_0_outer_2,
                          state.eyeradius_0_outer_3,
                        ],
                        inner: [
                          state.eyeradius_0_inner_0,
                          state.eyeradius_0_inner_1,
                          state.eyeradius_0_inner_2,
                          state.eyeradius_0_inner_3,
                        ],
                      },
                      {
                        outer: [
                          state.eyeradius_1_outer_0,
                          state.eyeradius_1_outer_1,
                          state.eyeradius_1_outer_2,
                          state.eyeradius_1_outer_3,
                        ],
                        inner: [
                          state.eyeradius_1_inner_0,
                          state.eyeradius_1_inner_1,
                          state.eyeradius_1_inner_2,
                          state.eyeradius_1_inner_3,
                        ],
                      },
                      {
                        outer: [
                          state.eyeradius_2_outer_0,
                          state.eyeradius_2_outer_1,
                          state.eyeradius_2_outer_2,
                          state.eyeradius_2_outer_3,
                        ],
                        inner: [
                          state.eyeradius_2_inner_0,
                          state.eyeradius_2_inner_1,
                          state.eyeradius_2_inner_2,
                          state.eyeradius_2_inner_3,
                        ],
                      },
                    ],
                    eyeColor: [
                      // build eyeColor manually
                      {
                        outer:
                          state.eyecolor_0_outer ?? state.fgColor ?? "#000000",
                        inner:
                          state.eyecolor_0_inner ?? state.fgColor ?? "#000000",
                      },
                      {
                        outer:
                          state.eyecolor_1_outer ?? state.fgColor ?? "#000000",
                        inner:
                          state.eyecolor_1_inner ?? state.fgColor ?? "#000000",
                      },
                      {
                        outer:
                          state.eyecolor_2_outer ?? state.fgColor ?? "#000000",
                        inner:
                          state.eyecolor_2_inner ?? state.fgColor ?? "#000000",
                      },
                    ],
                  }}
                />
                               {isRegisterQRSelected && (
                <div style={{display:"flex", fontSize:"18px", justifyContent:"center",fontWeight:"600", background:"#fff", marginTop:"-10px" }}>{reservedQRCId}</div>
                )}
                {/* {(userData?.isEnrolledInSocialNet && !userData?.isSocialNetPlanPaid) && (
  <div style={{ display: "flex", justifyContent: "center", fontSize: "10px", background:"#fff", marginTop:"-5px" }}>
    www.dirido.com
  </div>
)} */}
                </div>
              </div>
              <div
                className="app"
                style={{ background: "#fff", borderRadius: "5px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                  }}
                >
                  <div className="containerproperties1">
                    <div className="subcontainer1">
                      <p
                        style={{
                          textAlign: "center",
                          fontWeight: "500",
                          fontSize: "18px",
                        }}
                      >
                     {t('eye_radius')}
                      </p>
                    <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    gap: 20,
  }}
>
  {/* Top Left Eye */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: "1 1 300px",
      minWidth: 250,
      border: "1px solid #e0e0e0",
      borderRadius: 8,
      padding: 12,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
      {t("top_left_eye")}
    </div>

    <div
      style={{
        display: "flex",
        gap: 16,
        flexWrap: "wrap",
      }}
    >
      {/* Outer */}
      <div style={{ flex: 1, minWidth: 120 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("outer")}</div>
        {buildEyeRadiusInput("eyeradius_0_outer_0")}
        {buildEyeRadiusInput("eyeradius_0_outer_1")}
        {buildEyeRadiusInput("eyeradius_0_outer_2")}
        {buildEyeRadiusInput("eyeradius_0_outer_3")}
      </div>

      {/* Inner */}
      <div style={{ flex: 1, minWidth: 120 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("inner")}</div>
        {buildEyeRadiusInput("eyeradius_0_inner_0")}
        {buildEyeRadiusInput("eyeradius_0_inner_1")}
        {buildEyeRadiusInput("eyeradius_0_inner_2")}
        {buildEyeRadiusInput("eyeradius_0_inner_3")}
      </div>
    </div>
  </div>

  {/* Top Right Eye */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: "1 1 300px",
      minWidth: 250,
      border: "1px solid #e0e0e0",
      borderRadius: 8,
      padding: 12,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
      {t("top_right_eye")}
    </div>

    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
      <div style={{ flex: 1, minWidth: 120 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("outer")}</div>
        {buildEyeRadiusInput("eyeradius_1_outer_0")}
        {buildEyeRadiusInput("eyeradius_1_outer_1")}
        {buildEyeRadiusInput("eyeradius_1_outer_2")}
        {buildEyeRadiusInput("eyeradius_1_outer_3")}
      </div>

      <div style={{ flex: 1, minWidth: 120 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("inner")}</div>
        {buildEyeRadiusInput("eyeradius_1_inner_0")}
        {buildEyeRadiusInput("eyeradius_1_inner_1")}
        {buildEyeRadiusInput("eyeradius_1_inner_2")}
        {buildEyeRadiusInput("eyeradius_1_inner_3")}
      </div>
    </div>
  </div>

  {/* Bottom Left Eye */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: "1 1 300px",
      minWidth: 250,
      border: "1px solid #e0e0e0",
      borderRadius: 8,
      padding: 12,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
      {t("bottom_left_eye")}
    </div>

    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
      <div style={{ flex: 1, minWidth: 120 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("outer")}</div>
        {buildEyeRadiusInput("eyeradius_2_outer_0")}
        {buildEyeRadiusInput("eyeradius_2_outer_1")}
        {buildEyeRadiusInput("eyeradius_2_outer_2")}
        {buildEyeRadiusInput("eyeradius_2_outer_3")}
      </div>

      <div style={{ flex: 1, minWidth: 120 }}>
        <div style={{ fontSize: 12, marginBottom: 4 }}>{t("inner")}</div>
        {buildEyeRadiusInput("eyeradius_2_inner_0")}
        {buildEyeRadiusInput("eyeradius_2_inner_1")}
        {buildEyeRadiusInput("eyeradius_2_inner_2")}
        {buildEyeRadiusInput("eyeradius_2_inner_3")}
      </div>
    </div>
  </div>
   <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: "1 1 300px",
      minWidth: 250,
      border: "1px solid #ddd",
      borderRadius: 8,
      padding: 12,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
     {t('eye_color')}
    </div>

<div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div style={{ fontSize: 14 }}>{t('top_left_eye')}</div>
                          <div style={{ fontSize: 12 }}>{t('outer')}</div>
                          <InputField
                            name="eyecolor_0_outer"
                            type="color"
                            defaultValue={state.fgColor ?? "#000000"}
                            handleChange={handleChange}
                            hideLabel={true}
                          />
                          <div style={{ fontSize: 12 }}>{t('inner')}</div>
                          <InputField
                            name="eyecolor_0_inner"
                            type="color"
                            defaultValue={state.fgColor ?? "#000000"}
                            handleChange={handleChange}
                            hideLabel={true}
                          />
                        </div>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div style={{ fontSize: 14 }}>{t('top_right_eye')}</div>
                          <div style={{ fontSize: 12 }}>{t('outer')}</div>
                          <InputField
                            name="eyecolor_1_outer"
                            type="color"
                            defaultValue={state.fgColor ?? "#000000"}
                            handleChange={handleChange}
                            hideLabel={true}
                          />
                          <div style={{ fontSize: 12 }}>{t('inner')}</div>
                          <InputField
                            name="eyecolor_1_inner"
                            type="color"
                            defaultValue={state.fgColor ?? "#000000"}
                            handleChange={handleChange}
                            hideLabel={true}
                          />
                        </div>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div style={{ fontSize: 14 }}>{t('bottom_left_eye')}</div>
                          <div style={{ fontSize: 12 }}>{t('outer')}</div>
                          <InputField
                            name="eyecolor_2_outer"
                            type="color"
                            defaultValue={state.fgColor ?? "#000000"}
                            handleChange={handleChange}
                            hideLabel={true}
                          />
                          <div style={{ fontSize: 12 }}>{t('inner')}</div>
                          <InputField
                            name="eyecolor_2_inner"
                            type="color"
                            defaultValue={state.fgColor ?? "#000000"}
                            handleChange={handleChange}
                            hideLabel={true}
                          />
                        </div>
                      </div>
  </div>
</div>

                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: "10px" }}>
              {isRegisterQRSelected ? (
 <button
 className="btn btn-primary d-block "
 style={{
   display: "flex",
   width: "200px",
   marginInline: "auto",
 }}
 onClick={handleQRC1}
>
 {t('generate_qr_code')}
</button>
              ):(
                <button
                className="btn btn-primary d-block "
                style={{
                  display: "flex",
                  width: "200px",
                  marginInline: "auto",
                }}
                onClick={handleQRC}
              >
                {t('generate_qr_code')}
              </button>
              )}
             
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <Modal open={open} onClose={handleClose}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 300,
                  bgcolor: "white",
                  boxShadow: 24,
                  p: 4,
                  textAlign: "center",
                  borderRadius: "10px",
                  position: "relative",
                          }}
                        >
                          <button
                      onClick={handleClose}
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "20px",
                      }}
                    >
                      <AiOutlineClose />
                    </button>
                {qrCodeUrlImage  ? (<>
                   <Typography variant="h6" sx={{ mb: 2 }}>
                   {t("qrGeneratedSuccessfully")}
                 </Typography>
                   
                    <img src={qrCodeUrlImage} alt="Generated QR Code" width="200" />
                    
                   <div style={{ display: "flex" }}>
                           <button
                             className="btn btn-primary d-block "
                             style={{
                               display: "flex",
                               width: "200px",
                               marginInline: "auto",
                               marginTop:"10px"
                             }}
                             onClick={handleDownload}
                           >
                             {t('download_qr_code')}
                           </button>
                         </div>
                         </>
                ) : (
                   <Typography variant="h6" sx={{ mb: 2 }}>
                 {t("failedToLoadQrCode")}
                </Typography>
              )}
               
              </Box>
            </Modal>
    </>
  );
};

const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};


export default File;
